"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useSocket;
const react_1 = require("react");
const socket_io_client_1 = require("socket.io-client");
const http_1 = require("../utils/http");
// export default function useWebSocket(url: string) {
//   const [message, setMessage] = useState<WebSocketMessage | null>(null);
//   const socketRef = useRef<WebSocket | null>(null);
//   useEffect(() => {
//     socketRef.current = new WebSocket(url);
//     socketRef.current.onmessage = (event) => {
//       try {
//         const parsedData: WebSocketMessage = JSON.parse(event.data);
//         setMessage(parsedData);
//       } catch (error) {
//         console.error('Error parsing WebSocket message:', error);
//       }
//     };
//     return () => {
//       socketRef.current?.close();
//     };
//   }, [url]);
//   return { message };
// }
// export default function useSocket(eventType:any): Socket | null {
//     const [socket, setSocket] = useState<Socket | null>(null);
//     useEffect(() => {
//       const socketIo = io(`${AppSocketBaseUrl}:6002`, {
//         path: '/socket.io',
//         transports: ['websocket'],
//         secure: true,
//         rejectUnauthorized: false,
//         withCredentials: true,
//         extraHeaders: {
//           'Sec-WebSocket-Protocol': 'wss',
//         },
//       });
//       socketIo.on('connect', () => {
//         console.log('Socket.IO connecté, id:', socketIo.id);
//         socketIo.emit('join', eventType);
//       });
//       socketIo.on('connect_error', (err) => {
//         console.error('Erreur connexion Socket.IO:', err);
//       });
//       setSocket(socketIo);
//       return () => {
//         socketIo.disconnect();
//       };
//     }, []);
//     return socket;
// }
function useSocket() {
    const [socket, setSocket] = (0, react_1.useState)(null);
    const SOCKET_URL = `${http_1.AppSocketBaseUrl}:6002`;
    (0, react_1.useEffect)(() => {
        const socketIo = (0, socket_io_client_1.io)(SOCKET_URL, {
            path: "/socket.io",
            transports: ["websocket"],
            secure: true,
            rejectUnauthorized: false,
            withCredentials: true,
            extraHeaders: {
                "Sec-WebSocket-Protocol": "wss",
            },
        });
        socketIo.on("connect", () => {
            console.log("✅ Socket.IO connecté :", socketIo.id);
        });
        socketIo.on("connect_error", (err) => {
            console.error("❌ Erreur Socket.IO:", err);
        });
        setSocket(socketIo);
        return () => {
            socketIo.disconnect();
        };
    }, []);
    return socket;
}
